var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar-title',[_c('router-link',{attrs:{"to":"/"}},[_c('v-img',{staticClass:"mt-0",attrs:{"contain":"","src":_vm.logoPath,"width":"90px"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }